import BlogInnerSection from "../components/blog-light-sidebar/blog-inner-section";

export default function BlogLightSidebar() {
	return <BlogInnerSection theme="light" />;
}
